module.exports = __webpack_public_path__ + "static/media/meteringcase03.2c486264.png";